export const getPersonsOptions = (incomeEligibility, maxOccupants) => {
  const selectedPersons = incomeEligibility.reduce(
    (selectedMap, eligibleQualification) => {
      selectedMap[eligibleQualification.occupants] =
        eligibleQualification.maximum_income;
      return selectedMap;
    },
    {}
  );

  return Array.from(new Array(maxOccupants)).map((_, index) => {
    const value = String(index + 1);
    const option = { label: `${value} Person(s)`, value };

    if (selectedPersons[option.value]) {
      option.disabled = true;
    }
    return option;
  });
};

export const getIsAddRowDisabled = (incomeEligibility, maxOccupants) => {
  if (incomeEligibility.length > maxOccupants - 1) {
    return true;
  }

  return (
    incomeEligibility.length !== 0 &&
    incomeEligibility.some(
      (qualification) =>
        !qualification.occupants || !qualification.maximum_income
    )
  );
};
